import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const pillars = [
  {
    id: 'telecoms',
    titleKey: 'programs_hero_card_pillar1',
    image: '/images/research/cati-lab.jpg',
    link: '/programs/reseaux-telecoms'
  },
  {
    id: 'informatique',
    titleKey: 'programs_pillar_i',
    image: '/images/research/studio-app.jpg',
    link: '/programs/informatique'
  },
  {
    id: 'energie',
    titleKey: 'programs_pillar_e',
    image: '/images/campus/espace-01.jpg',
    link: '/programs/electricite-energies'
  }
];

export default function PillarsSection() {
  const { t } = useTranslation();

  return (
    <section id="piliers" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-navy text-4xl font-black uppercase tracking-tighter border-b-2 border-gray-100 pb-5 mb-12">
          {t('section_news_pillars', 'Actualités et nos piliers')}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {pillars.map((pillar) => (
            <Link 
              key={pillar.id} 
              to={pillar.link}
              className="group flex flex-col"
            >
              <div className="overflow-hidden mb-6 aspect-[16/10] shadow-md rounded-sm border border-gray-100">
                <img 
                  src={pillar.image} 
                  alt={pillar.id} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <h3 className="text-navy text-2xl font-black group-hover:underline mb-4 leading-tight tracking-tight">
                {t(pillar.titleKey)}
              </h3>
              <p className="text-gray-600 leading-relaxed font-light line-clamp-3">
                {t(pillar.id === 'telecoms' ? 'programs_pillar_t_desc' : 'programs_pillar_i_desc')}
              </p>
            </Link>
          ))}

          {/* 7 Steps Special Card */}
          <Link 
            to="/programs"
            className="group"
          >
            <div className="bg-gold p-10 h-full flex flex-col aspect-[16/10] justify-center items-center text-center shadow-lg relative overflow-hidden rounded-sm transition-all duration-300 group-hover:-translate-y-2 group-hover:shadow-xl">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full transition-transform group-hover:scale-110"></div>
              <h3 className="text-navy text-3xl font-black uppercase tracking-tighter mb-5 relative z-10">
                {t('programs_7step_title_short', '7 Étapes Entrepreneuriales')}
              </h3>
              <p className="text-navy font-bold mb-8 relative z-10 leading-snug">
                {t('programs_7step_subtitle', "De l'Étudiant-Entrepreneur à l'Entrepreneur-Industriel.")}
              </p>
              <div className="inline-flex items-center gap-2 text-navy font-black underline group-hover:no-underline uppercase tracking-widest text-sm relative z-10 transition-all">
                {t('common_learn_more_short', 'En savoir plus')}
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </div>
            </div>
          </Link>
        </div>

        <div className="mt-16 text-right">
          <Link 
            to="/news" 
            className="inline-flex items-center gap-2 text-navy font-black underline hover:text-gold transition-all duration-300 uppercase tracking-widest text-sm"
          >
            {t('link_view_all_projects', 'Voir plus de projets et histoires')}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
